import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, classBorderLabelDark, classbtCinzaClaro, classbtColunasAzul, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark,
    classLabel, classLabelDark, Clientes, ClientesSearchBox, RelatorioConsultaVendas, Usuarios,
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { ClientesService } from "../Clientes/ClientesService"
import { DataSearch, SearchBox } from "../../Components/SearchBox/SearchBox"
import { IoSearch } from "react-icons/io5"
import moment from "moment"
import { TbShoppingCartSearch } from "react-icons/tb"
import { UserService } from "../Users/User.service"
import { GridConsultaVendas } from "../../Components/GridProducts/GridConsultaVendas"
import { VendasService } from "./vendasService"
import { ReportVendaFinalizadaBobina } from "./pdf/report-venda-finalizadaBobina"
import { ModalImpress } from "../../Components/Modal/modal-impress"
import { ReportVendaFinalizadaA4 } from "./pdf/report-venda-finalizadaA4"
import { ModalFecharVenda } from "../../Components/Modal/modal-fechar-venda"
import { AiOutlineClear } from "react-icons/ai"

export const ConsultarVendas = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD');

    let dateF = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD');


    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")


    // -----------------------------------------------
    // ------------- ATRIBUTOS -----------------------
    // -----------------------------------------------
    const [vendasList, setVendasList] = useState<any>([])

    const [clientes, setClientes] = useState<ClientesSearchBox[]>([])
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])
    const [idCliente, setIdCliente] = useState(0)

    const [datai, setDatai] = useState<string>(dateI)
    const [dataf, setDataf] = useState<string>(dateF)

    const [usuarios, setUsuarios] = useState<DataSearch[]>([])
    const [usuariosDefault, setUsuariosDefault] = useState<Usuarios[]>([])
    const [idVendedor, setIdVendedor] = useState(0)
    //const [nomeVendedor, setNomeVendedor] = useState("")

    const [statusVenda, setStatusVenda] = useState("N")
    //const [statusVendaCopy, setStatusVendaCopy] = useState("N")


    //const [searchBoxResponsivo, setSearchBoxResponsivo] = useState<boolean>(false)

    // -----------------------------------------------
    // ------------- MODAL ---------------------------
    // -----------------------------------------------
    const [visibleImpressVenda, setVisibleImpressVenda] = useState(false)
    const [visibleImpressVendaBobina, setVisibleImpressVendaBobina] = useState(false)
    const [visibleImpressVendaA4, setVisibleImpressVendaA4] = useState(false)


    //const [loadingImpressVendaA4, setLoadingImpressVendaA4] = useState(false)
    //const [loadingImpressVendaBobina, setLoadingImpressVendaBobina] = useState(false)


    // -----------------------------------------------
    // ------------- IMPRESSÕES ----------------------
    // -----------------------------------------------
    const [dadosParaImpressaoaA4_Bobina, setDadosParaImpressaoA4_Bobina] = useState<RelatorioConsultaVendas[]>([])

    //const [relatorios, setRelatorios] = useState({})
    //const [id, setId] = useState(0)

    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)
    const [visibleSearchBoxVendedor, setVisibleSearchBoxVendedor] = useState<boolean>(false)

    const [visibleStatusVenda, setVisibleStatusVenda] = useState(false)

    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getClientes = async () => {
        setLoading(true)

        try {

            const resp = await ClientesService.GetListCliente()
            setClientes(resp.data)
            setClientesList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar os clientes')

        } finally {
            setLoading(false)
        }
    }

    const getUsuarios = async () => {
        setLoading(true)

        try {

            const resp = await UserService.UsuarioList()
            if(!resp.error){

                let newUsuariosList: DataSearch[] = resp.data.map((item: { id: number; nome: string }) => { return { id: item.id, description: item.nome } })
                setUsuarios(newUsuariosList)

                setUsuariosDefault(resp.data)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar os usuários')

        } finally {
            setLoading(false)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroConsultaVendas") as HTMLDivElement

        const modalStates = [
            visibleSearchBoxCliente,
            visibleSearchBoxVendedor,
            visibleImpressVenda,
            visibleImpressVendaA4,
            visibleImpressVendaBobina,
        ]

        if (modalStates.every(state => !state) && (e.code === "Enter" || e.code === "NumpadEnter") && menuFiltro.classList.contains("max-h-[600px]") && !loading) {
            await handleFilterClick();
        }

    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter);

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter);
        };

    }, [datai, dataf, idCliente, idVendedor, statusVenda, visibleImpressVenda, visibleImpressVendaA4, visibleImpressVendaBobina, visibleSearchBoxCliente, visibleSearchBoxVendedor, loading])

    useEffect(() => {
        if(visibleStatusVenda){
            handleFilterClick()
        }
        
    }, [statusVenda])

    useEffect(() => {
        getClientes()
        getUsuarios()
        setVisibleStatusVenda(true)
    }, [])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------- IMPRESSÕES -----------------------------------------------------
    const imprimirVenda = async () => {

        /*
        const relatorio = {

            id_venda: id,

        }

        setLoadingImpressVendaBobina(true)
        const resp = await VendasService.ConsultarVendas(relatorio);
        setLoadingImpressVendaBobina(false)

        if (resp) {

            setDadosParaImpressao(resp)

            setVisibleImpressVenda(false)
            setVisibleImpressVendaBobina(true)

            minimizarFiltro()
        }
        */
    }

    const fecharModalBobina = useCallback(() => {
        setVisibleImpressVendaBobina(false)
        setVisibleImpressVenda(false)
    }, [])

    const fecharModalA4 = useCallback(() => {
        setVisibleImpressVendaA4(false)
        setVisibleImpressVenda(false)
    }, [])

    const imprimirVendaA4 = useCallback(async () => {
        setVisibleImpressVendaA4(true)
    }, [])

    const imprimirVendaBobina = useCallback(async () => {
        setVisibleImpressVendaBobina(true)
    }, [])

    const abrirModalImpress = useCallback(async (id: any) => {

        setVisibleImpressVenda(true)
        setVisible(false)
        handleInputFocus()

        try {

            const relatorio = {
                id_venda: id,
            }

            const resp = await VendasService.ConsultarVendas(relatorio)

            if (resp) {

                setDadosParaImpressaoA4_Bobina(resp.data) 
                //minimizarFiltro()
            }

            //setId(id)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível realizar a impressão. Por favor, tente novamente')
        }

    }, [])

    const fecharModalImpress = useCallback(() => {
        setVisibleImpressVenda(false)
    }, [])

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatusVenda(e.target.value)
    }

    const handleFilterClick = async () => {

        setLoading(true)
        setVisible(false)
        setVendasList([])
        handleInputFocus()

        try {

            const relatorio = {
                datai: datai,
                dataf: dataf,
                id_vendedor: idVendedor,
                id_cliente: idCliente,
                tipo_venda: statusVenda

            }

            const vendas = await VendasService.ConsultarVendas(relatorio);

            //setStatusVendaCopy(statusVenda)
            setVendasList(vendas.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar as vendas')

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const filterDados = useCallback(async () => {

        setVisible(false)
        handleInputFocus()

        try {

            const relatorio = {
                datai: datai,
                dataf: dataf,
                id_vendedor: idVendedor,
                id_cliente: idCliente,
                tipo_venda: statusVenda

            }

            const vendas = await VendasService.ConsultarVendas(relatorio);

            //setStatusVendaCopy(statusVenda)
            setVendasList(vendas.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar as vendas')

        }
    }, [vendasList, datai, dataf, idVendedor, idCliente, statusVenda]);

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroConsultaVendas") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsConsultaVendas") as HTMLDivElement

        handleInputFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[600px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[600px]")) {

                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")


            } else {

                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur();
        }


    }

    const handleLimparFiltros = () => {

        setDatai(dateI)
        setDataf(dateF)
        //setStatusVenda("N")
        //setStatusVendaCopy("N")
        setIdCliente(0)
        setIdVendedor(0)

        handleInputFocus()
    }

    const minimizarFiltro = () => {

        let menuFiltro = document.getElementById("divMenuFiltroConsultaVendas") as HTMLDivElement
        let menuInputs = document.getElementById("divInputsConsultaVendas") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.remove("max-h-[370px]")
            menuFiltro.classList.add("max-h-[0px]")

            //setSearchBoxResponsivo(false)

            menuInputs.classList.add("invisible")

        }
    }

    const handleInputFocus = () => {
        setVisibleSearchBoxCliente(false)
        setVisibleSearchBoxVendedor(false)
    }

    //--------------------------------------------------------------------------------------------- CLIENTE ------------------------------------------------------------------------------------------//
    const handleClearClienteSelecionado = useCallback(() => {
        const newClienteList = [...clientes || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [clientes])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        if (v) {
            const newClienteList = [...clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxVendedor(false)
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }


    //------------------------------------------------------------------- USUARIO ----------------------------------------------------------------------------------- ||
    const handlerClearUsuarioSelecionado = useCallback(() => {
        setUsuariosOriginal()
        setIdVendedor(0)

        setVisibleSearchBoxVendedor(false)
    }, [usuarios])

    const handleFilterUsuarioClick = useCallback((descricao: string) => {
        if (descricao.trim() === "") {
            setUsuariosOriginal()
        } else {
            let newUsuariosList = usuariosDefault.filter(item => item.nome.toLocaleLowerCase().startsWith(descricao.toLocaleLowerCase()))
            let newUsuariosSearchList = newUsuariosList.map(item => { return { id: item.id, description: item.nome } })
            setUsuarios(newUsuariosSearchList)
        }
    }, [usuarios])

    const handleUsuarioSelectClick = useCallback((data: DataSearch) => {

        if (data) {
            setUsuariosOriginal()
            setIdVendedor(data.id)
            //setNomeVendedor(data.description)
        }

        setVisibleSearchBoxVendedor(false)
    }, [usuarios])

    const setUsuariosOriginal = useCallback(() => {
        let newUsuariosList: any[] = [...usuariosDefault]
        newUsuariosList = usuariosDefault.map(item => { return { id: item.id, description: item.nome } })
        setUsuarios(newUsuariosList)
    }, [usuarios])

    const clickSearchBoxVendedor = useCallback(() => {
        setVisibleSearchBoxVendedor((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCliente(false)
                inputFocusVendedor()
            }
            return newState
        })
    }, [])

    const inputFocusVendedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-vendedor`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }


    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-8 md:col-span-10 flex flex-row items-center`}>
                            <TbShoppingCartSearch className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Consultar Vendas</span>
                        </div>

                        <div className={`relative col-span-4 md:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                    </div>

                    <div id='divInputsConsultaVendas' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroConsultaVendas' className={`relative max-h-[0px] h-[540px] sm:h-[330px] md:h-[260px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id='data-inicial-consultar-vendas' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={handleInputFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="data-inicial-consultar-vendas" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data do Periodo Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id='data-final-consultar-vendas' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={handleInputFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="data-final-consultar-vendas" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data do Periodo Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <select id="statusDaVenda" className={`${classInput} ${classInputDark}`} value={statusVenda} onFocus={handleInputFocus} onChange={handleChangeStatus}>
                                    <option value="N">Não Finalizadas</option>
                                    <option value="F">Finalizadas</option>
                                </select>
                                <label htmlFor="statusDaVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div className={`relative col-span-12`}>
                                <span className={`text-[14px] text-slate-500 dark:text-slate-300`}>Filtros Avançados</span>
                                <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700 w-[100%] mt-2`} />
                            </div>

                            <div className={`relative col-span-12 md:col-span-6 mt-2`}>
                                <SearchBox
                                    dataList={clientesList}
                                    idRegistro={idCliente || undefined}
                                    label='Cliente'
                                    componentId='cliente'
                                    visibleTAB={visibleSearchBoxCliente}
                                    clearDataClick={handleClearClienteSelecionado}
                                    setDataClick={handleClienteSelectClick}
                                    filterDataClick={handleFilterClienteClick}
                                    clicado={clickSearchBoxCliente}
                                />
                            </div>

                            <div className={`relative col-span-12 md:col-span-6 mt-2`}>
                                <SearchBox
                                    dataList={usuarios}
                                    idRegistro={idVendedor}
                                    label='Vendedor'
                                    componentId='vendedor'
                                    visibleTAB={visibleSearchBoxVendedor}
                                    setDataClick={handleUsuarioSelectClick}
                                    clearDataClick={handlerClearUsuarioSelecionado}
                                    filterDataClick={handleFilterUsuarioClick}
                                    clicado={clickSearchBoxVendedor}
                                />
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        <GridConsultaVendas
                            venda={vendasList}
                            tipo={statusVenda === 'N' ? 'N' : 'F'}
                            imprimir={abrirModalImpress}
                            handleUpdateVendasList={filterDados}

                        />

                    </div>

                    <ReportVendaFinalizadaBobina
                        visible={visibleImpressVendaBobina}
                        dadosReimpressao={dadosParaImpressaoaA4_Bobina}
                        closeModalEvent={fecharModalBobina}
                        reciboReimprimido={true}
                    />

                    <ReportVendaFinalizadaA4
                        visible={visibleImpressVendaA4}
                        dadosReimpressao={dadosParaImpressaoaA4_Bobina}
                        closeModalEvent={fecharModalA4}
                    />

                    <ModalImpress
                        visible={visibleImpressVenda}
                        titulo="Imprimir venda"
                        msg="Escolha o método de impressão"
                        buttonConfirmClickA4={imprimirVendaA4}
                        buttonConfirmClickBOBINA={imprimirVendaBobina}
                        closeModalEvent={fecharModalImpress}
                    />

                </div>

            </div>

        </Template>

    )
}